import Vue from 'vue';
import { Mixin } from 'vue-mixin-decorator';
import UserService from '@/services/UserService';

@Mixin
export default class LuanchGameMixin extends Vue {
  public banks: Array<any> = [];

  public userService = new UserService();

  public async luanchGame() {
    try {
      const { data } = await this.userService.luanchGAme();
      window.open(`https://www.betflik.com/login/apilogin/${data.data.login_token}`, '_blank');
    } catch (e) {
      this.$store.commit('Snackbar/showNotification', { message: 'เกิดข้อผิดพลาดระหว่างเปิดเกม', error: true });
    }
  }
}
